import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { FaHeart, FaRegHeart } from 'react-icons/fa';
import { ProductContext } from '../context/ProductContext';
import StarRating from './StarRating';

function CardComponent({ product }) {
  const { wishlist, toggleWishlist } = useContext(ProductContext);
  const inWishlist = wishlist.some((p) => p.id === product.id);

  const discountPercentage = product.discountPercentage || 0;
  const originalPrice = Math.round(product.price / (1 - discountPercentage / 100));

  return (
    <div className="group relative flex h-full flex-col overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm transition hover:shadow-lg">
      <button
        type="button"
        onClick={(e) => {
          e.preventDefault();
          toggleWishlist(product);
        }}
        aria-label={inWishlist ? 'Remove from wishlist' : 'Add to wishlist'}
        className="absolute right-2 top-2 z-10 flex h-8 w-8 items-center justify-center rounded-full bg-white/90 text-rose-500 shadow hover:bg-white"
      >
        {inWishlist ? <FaHeart /> : <FaRegHeart />}
      </button>

      <Link to={`/product/${product.id}`} className="flex flex-1 flex-col">
        <div className="relative aspect-square w-full overflow-hidden bg-gray-50">
          <img
            src={product.thumbnail}
            alt={product.title}
            loading="lazy"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = 'https://placehold.co/300x300?text=No+Image';
            }}
            className="h-full w-full object-cover transition group-hover:scale-105"
          />
          {discountPercentage > 0 && (
            <span className="absolute left-2 top-2 rounded-full bg-rose-600 px-2 py-0.5 text-xs font-semibold text-white">
              -{Math.round(discountPercentage)}%
            </span>
          )}
        </div>

        <div className="flex flex-1 flex-col gap-1.5 p-3">
          {product.brand && (
            <span className="w-fit rounded-full bg-gray-100 px-2 py-0.5 text-[11px] font-medium text-gray-600">
              {product.brand}
            </span>
          )}
          <h3 className="line-clamp-2 text-sm font-medium text-gray-900">{product.title}</h3>

          <div className="mt-auto flex items-baseline gap-2">
            <span className="text-base font-bold text-gray-900">${product.price}</span>
            {discountPercentage > 0 && (
              <span className="text-xs text-gray-400 line-through">${originalPrice}</span>
            )}
          </div>

          <div className="flex items-center justify-between pt-1">
            <StarRating rating={product.rating} size={12} />
            <span
              className={`text-xs font-medium ${
                product.stock > 10 ? 'text-emerald-600' : 'text-rose-600'
              }`}
            >
              {product.stock > 10 ? 'In stock' : `Only ${product.stock} left`}
            </span>
          </div>
        </div>
      </Link>
    </div>
  );
}

export default CardComponent;
